goog.provide("shadow.js.shim.module$moment_timezone$default");
shadow.js.shim.module$moment_timezone$default = shadow.js.shim.module$moment_timezone.default;
